import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_DeliveryNotes } from "./SIV_DeliveryNotes";
import type { SIV_Order } from "./SIV_Order";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceiptProcessAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  acceptedBy?: _User | undefined;
  blockingIndicator?: string | undefined;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  comment?: string | undefined;
  controlledBy?: _User | undefined;
  date: Date;
  deliveryNote?: SIV_DeliveryNotes | undefined;
  directory?: string | undefined;
  directoryDate?: Date | undefined;
  no: string;
  notes: any[];
  notFoundValues: any;
  order: SIV_Order;
  printDate?: Date | undefined;
  recordedBy?: _User | undefined;
  statusCodes: any[];
  storageLocation?: string | undefined;
  supplier?: string | undefined;
  tenant: OD3_Tenant;
  transportationProvider?: string | undefined;
  weight?: number | undefined;
  xcellizeNo?: string | undefined;
}

export class SIV_GoodsReceiptProcess extends Parse.Object<SIV_GoodsReceiptProcessAttributes> {
  static className: string = "SIV_GoodsReceiptProcess";

  constructor(data?: Partial<SIV_GoodsReceiptProcessAttributes>) {
    super("SIV_GoodsReceiptProcess", data as SIV_GoodsReceiptProcessAttributes);
  }

  get acceptedBy(): _User | undefined {
    return super.get("acceptedBy");
  }
  set acceptedBy(value: _User | undefined) {
    super.set("acceptedBy", value);
  }

  get blockingIndicator(): string | undefined {
    return super.get("blockingIndicator");
  }
  set blockingIndicator(value: string | undefined) {
    super.set("blockingIndicator", value);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get comment(): string | undefined {
    return super.get("comment");
  }
  set comment(value: string | undefined) {
    super.set("comment", value);
  }

  get controlledBy(): _User | undefined {
    return super.get("controlledBy");
  }
  set controlledBy(value: _User | undefined) {
    super.set("controlledBy", value);
  }

  get date(): Date {
    return super.get("date");
  }
  set date(value: Date) {
    super.set("date", value);
  }

  get deliveryNote(): SIV_DeliveryNotes | undefined {
    return super.get("deliveryNote");
  }
  set deliveryNote(value: SIV_DeliveryNotes | undefined) {
    super.set("deliveryNote", value);
  }

  get directory(): string | undefined {
    return super.get("directory");
  }
  set directory(value: string | undefined) {
    super.set("directory", value);
  }

  get directoryDate(): Date | undefined {
    return super.get("directoryDate");
  }
  set directoryDate(value: Date | undefined) {
    super.set("directoryDate", value);
  }

  get no(): string {
    return super.get("no");
  }
  set no(value: string) {
    super.set("no", value);
  }

  get notes(): any[] {
    return super.get("notes");
  }
  set notes(value: any[]) {
    super.set("notes", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order {
    return super.get("order");
  }
  set order(value: SIV_Order) {
    super.set("order", value);
  }

  get printDate(): Date | undefined {
    return super.get("printDate");
  }
  set printDate(value: Date | undefined) {
    super.set("printDate", value);
  }

  get recordedBy(): _User | undefined {
    return super.get("recordedBy");
  }
  set recordedBy(value: _User | undefined) {
    super.set("recordedBy", value);
  }

  get statusCodes(): any[] {
    return super.get("statusCodes");
  }
  set statusCodes(value: any[]) {
    super.set("statusCodes", value);
  }

  get storageLocation(): string | undefined {
    return super.get("storageLocation");
  }
  set storageLocation(value: string | undefined) {
    super.set("storageLocation", value);
  }

  get supplier(): string | undefined {
    return super.get("supplier");
  }
  set supplier(value: string | undefined) {
    super.set("supplier", value);
  }

  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }

  get transportationProvider(): string | undefined {
    return super.get("transportationProvider");
  }
  set transportationProvider(value: string | undefined) {
    super.set("transportationProvider", value);
  }

  get weight(): number | undefined {
    return super.get("weight");
  }
  set weight(value: number | undefined) {
    super.set("weight", value);
  }

  get xcellizeNo(): string | undefined {
    return super.get("xcellizeNo");
  }
  set xcellizeNo(value: string | undefined) {
    super.set("xcellizeNo", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_GoodsReceiptProcess",
  SIV_GoodsReceiptProcess,
);
